import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen)
    };


    return (
        <nav className="container mx-auto px-4 py-4 border-b-2 border-gray-300 flex justify-between items-center">
            <h1 className='text-2xl'>Fintan Gallagher</h1>
            <div className="flex items-center">
                <button
                    className="block lg:hidden text-2xl"
                    onClick={toggleMenu}
                >
                    &#9776;
                </button>
                <div className={`lg:flex lg:space-x-4 ml-auto ${isOpen ? 'block': 'hidden'}`}>
                    <Link to="/" className="text-2xl block lg:inline-block text-2xl py-2 lg:py-0 lg:px-4">Home</Link>
                    <Link to="/about" className="text-2xl block lg:inline-block text-2xl py-2 lg:py-0 lg:px-4">About</Link>
                    <Link to="/projects" className="text-2xl block lg:inline-block text-2xl py-2 lg:py-0 lg:px-4">Projects</Link>
                    <Link to="/music" className="text-2xl block lg:inline-block text-2xl py-2 lg:py-0 lg:px-4">Music</Link>
                    <Link to="/contact" className="text-2xl block lg:inline-block text-2xl py-2 lg:py-0 lg:px-4">Contact Me</Link>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;